<template>
  <div id="signup">
    <ApopBar/>
    <AccessRequest />
  </div>

</template>

<script>
  import AccessRequest from '../components/AccessRequest'
  import ApopBar from '../components/ApopBar'

  export default {
    name: 'signup',
  components: {
    ApopBar,
    AccessRequest
  }
}

</script>

<style>

</style>
